export const filterByAllFields = <T extends object>(arr: T[], searchTerm: string) => {
  return arr.filter((item) =>
    Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchTerm.toLowerCase()),
    ),
  );
};
